<template>
	<li :class="`auctionListItem--type-${auction.type} ${colorClass}`">
		<div :class="`auctionItem d-flex auctionItem--type-${auction.type} ${colorClass}`">
			<div v-if="auction.type === 'LOWEST_UNIQUE'" class="badge-LOWEST_UNIQUE">
				{{ $t('home.auction_item_badge_lowest_unique') }}
			</div>
			<div v-else-if="auction.maxPrice" class="badge-MAX_BID">
				{{ $t('home.auction_item_max_info') }}
			</div>
			<div class="auctionItem_leftSide">
				<div class="auctionItem_statusBar">
					<div v-if="auction.status != 'FINISHED'">
						<i class="fas fa-clock"></i> {{ lockTime }}
						<span>{{ $t('home.auction_item_timer_title_' + auction.status) }}</span>
					</div>
					<div v-else-if="auction.type === 'LOWEST_UNIQUE' && auction.questionnaireState != 'SUCCESS'">
						{{
							$t(
								'home.auction_item_timer_text_lu_' +
									(auction.questionnaireState === 'FAIL' ? 'FAIL' : auction.leadingBidder != null ? 'WAITING' : 'FAIL')
							)
						}}
					</div>
					<div v-else>
						{{ $t('home.auction_item_timer_text_' + (auction.paymentStatus ? auction.paymentStatus : 'NULL')) }}
					</div>
				</div>
				<template v-if="auction.photoUrls && auction.photoUrls.length > 0">
					<img
						@click="
							openInfoPopup()
							btnSfx()
						"
						:src="auction.photoUrls[viewImage]"
					/>
					<a href="#" @click.prevent="viewImage - 1 >= 0 ? --viewImage : (viewImage = 0)"><i class="fas fa-chevron-circle-left"></i></a>
					<a href="#" @click.prevent="viewImage + 1 < auction.photoUrls.length - 1 ? viewImage++ : (viewImage = auction.photoUrls.length - 1)"
						><i class="fas fa-chevron-circle-right"></i
					></a>
				</template>
			</div>
			<div class="auctionItem_rightSide">
				<a v-if="currentTab === 0" href="#" class="auctionItem_addToFav" @click.prevent="togggleFavorites(auction)">
					<i :class="auction.favourite ? 'fas fa-heart' : 'far fa-heart'" />
				</a>
				<h5
					@click="
						openInfoPopup()
						btnSfx()
					"
				>
					{{ auction.name }}
				</h5>
				<div
					@click="
						openInfoPopup()
						btnSfx()
					"
					class="auctionItem_info"
				>
					{{ $t('home.auction_item_label_info') }}
					<a href="#">{{ $t('home.auction_item_label_view_more') }} <i class="fas fa-chevron-right"></i></a>
				</div>
				<p>
					{{ auction.description.length > 150 ? auction.description.substring(0, 150) + '...' : auction.description }}
				</p>

				<div v-if="auction.leadingBidder !== undefined" class="auctionItem_highestBidder">
					<h4>
						{{ $t('home.auction_item_label_offer_' + (auction.status === 'FINISHED' ? 'end' : 'current')) }}
					</h4>
					<div>
						<img
							class="profileImage"
							:src="auction.leadingBidder.avatarUrl !== undefined ? auction.leadingBidder.avatarUrl : '/images/male-default.png'"
						/>
						<b class="flex-grow-1 text-truncate">{{ auction.leadingBidder.username }}</b>
						<template v-if="auction.leadingPrice">
							<b>{{ auction.leadingPrice.toLocaleString('sr-RS') }}</b>
							<img class="diamond" :src="user.mtsCustomer ? '/images/rubins.png' : '/images/diamond.png'" />
						</template>
					</div>
				</div>
				<div v-else-if="auction.type === 'STANDARD'" class="auctionItem_startBid">
					<h4>{{ $t('home.auction_item_label_offer_start') }}</h4>
					<b>{{ auction.startPrice.toLocaleString('sr-RS') }}</b>
					<img class="diamond" :src="user.mtsCustomer ? '/images/rubins.png' : '/images/diamond.png'" />
				</div>
				<div v-if="auction.maxPrice" @click="openMaxPriceInfoPopup" class="auctionItem_maxBid">
					<span
						v-html="
							$t('home.auction_item_max_price', {
								max_price: auction.maxPrice.toLocaleString('sr-RS'),
							})
						"
					></span>
					<img class="diamond" :src="user.mtsCustomer ? '/images/rubins.png' : '/images/diamond.png'" />
				</div>
			</div>
		</div>
		<div v-if="auction.status === 'PENDING'" class="auctionItem_actions">
			<p class="mb-1">{{ $t('home.auction_item_bottom_info_panding') }}</p>
			<h3 class="font-weight-bold text-danger">
				{{ lockTime }}
			</h3>
		</div>
		<div v-else-if="isMyLeading && auction.status != 'FINISHED'" class="auctionItem_actions">
			<h5 class="my-3 text-orange">
				{{ $t('home.auction_item_me_leading_info') }}
			</h5>
		</div>
		<div v-else-if="auction.status != 'FINISHED'" class="auctionItem_actions">
			<b-button
				@click="
					openBidPopup()
					btnSfx()
				"
				:variant="auction.type === 'LOWEST_UNIQUE' ? 'yellow' : 'primary'"
				size="lg"
				>{{ $t('home.auction_item_btn_bid') }}</b-button
			>
		</div>
		<div
			v-else-if="auction.type === 'LOWEST_UNIQUE' && isMyLeading && auction.questionnaireState !== 'FAIL' && auction.paymentStatus === 'WAITING'"
			class="auctionItem_actions"
		>
			<b-button
				@click="
					openRequestPopup()
					btnSfx()
				"
				variant="orange"
				size="lg"
				>{{ $t('home.auction_item_btn_claim') }}</b-button
			>
		</div>
		<div v-else-if="auction.type !== 'LOWEST_UNIQUE' && isMyLeading && ['WAITING', 'ERROR'].includes(auction.paymentStatus)" class="auctionItem_actions">
			<b-button
				@click="
					openRequestPopup()
					btnSfx()
				"
				variant="orange"
				size="lg"
				>{{ $t('home.auction_item_btn_claim') }}</b-button
			>
		</div>
		<div
			v-if="
				!isMyLeading &&
				auction?.mtsCustomerCategory &&
				!(auction.mtsCustomerCategory?.name === 'ANY' || user.mtsCustomerCategory.id === auction.mtsCustomerCategory.id)
			"
			class="auctionItem_locked"
		>
			<div class="auctionItem_lockedInfo">
				<i class="fas fa-lock"></i>
				<h6
					v-html="
						$t('home.auction_type_locked', {
							name: auction.mtsCustomerCategory?.friendlyName || auction.mtsCustomerCategory.name,
						})
					"
				></h6>
				<a href="https://adbaloo.mobi/loyalty-info/mts" target="_blank">{{ $t('home.more_info_locked') }}</a>
			</div>
		</div>
	</li>
</template>
<script>
import moment from 'moment'
import Vue from 'vue'
import api from '../../api'

const AuctionListItem = Vue.component('auction-list-item', {
	props: {
		auction: Object,
		currentTab: Number,
	},

	data() {
		return {
			lockTime: undefined,
			viewImage: 0,
		}
	},

	endDateTimer: null,

	computed: {
		user() {
			return this.$store.state.auth.user
		},

		networkTimeDiff() {
			return this.$store.state.config.networkTimeDiff
		},

		isMyLeading() {
			return !!this.auction.leadingBidder && this.auction.leadingBidder.id === this.user.id
		},

		colorClass() {
			if (this.auction.status === 'FINISHED') {
				if (this.auction.type === 'LOWEST_UNIQUE' && this.auction.questionnaireState != 'SUCCESS') {
					if (this.auction.questionnaireState === 'FAIL' || this.auction.leadingBidder) return 'auction-theme-red'
					else return 'auction-theme-yellow'
				} else if (this.isMyLeading) {
					switch (this.auction.paymentStatus) {
						case 'ERROR':
							return 'auction-theme-red'
						case 'AWARDED':
							return 'auction-theme-green'
						case 'WAITING':
							return 'auction-theme-yellow'
						case 'PROCESSING':
							return 'auction-theme-purple'
						default:
							return 'auction-theme-blue'
					}
				} else {
					return 'auction-theme-blue'
				}
			} else {
				if (this.auction.status === 'PENDING') return 'auction-theme-panding'
				else if (this.auction.type === 'LOWEST_UNIQUE') return 'auction-theme-blue'
				else if (this.auction.maxPrice > 0) return 'auction-theme-max-red'
				else if (this.auction.mtsCustomerCategory) return 'auction-theme-mts'
				else return 'auction-theme-default'
			}
		},
	},

	methods: {
		btnSfx() {
			this.$store.dispatch('sound/sfx', 'Button')
		},

		isAfterNow(time) {
			return time != undefined && moment.utc(time).isAfter(moment.utc() + this.networkTimeDiff)
		},

		clearTimers() {
			if (this.endDateTimer != null) {
				clearInterval(this.endDateTimer)
				this.endDateTimer = null
			}
		},

		openInfoPopup() {
			this.$root.$emit('setHomeView', {
				view: 'auction-info',
				target: { ...this.auction },
			})
		},

		openBidPopup() {
			this.$root.$emit('setHomeView', {
				view: 'auction-bid',
				target: { ...this.auction },
			})
		},

		openMaxPriceInfoPopup() {
			this.$bvModal
				.msgBoxOk(this.$t('home.auction_max_price_info_popup_text'), {
					title: this.$t('home.auction_max_price_info_popup_title'),
					size: 'sm',
					buttonSize: 'lg',
					okTitle: this.$t('base.btn_ok'),
					modalClass: 'confirmModal',
					hideHeaderClose: false,
					centered: true,
				})
				.then((value) => {
					this.$store.dispatch('sound/sfx', 'Button')
				})
		},

		openRequestPopup() {
			const $this = this

			if (this.auction.type === 'LOWEST_UNIQUE' && this.auction?.questionnaireState === 'PENDING')
				this.$bvModal
					.msgBoxConfirm(this.$t('home.auction_lu_question_confirm_popup_text'), {
						title: this.$t('home.auction_lu_question_confirm_popup_title'),
						size: 'sm',
						buttonSize: 'lg',
						okTitle: this.$t('home.auction_lu_question_confirm_popup_start_btn'),
						cancelTitle: this.$t('home.auction_lu_question_confirm_popup_next_time_btn'),
						modalClass: 'confirmModal',
						hideHeaderClose: false,
						centered: true,
					})
					.then((value) => {
						if (value) {
							$this.$root.$emit('setHomeView', {
								view: 'auction-question',
								target: { ...this.auction },
							})
						}
					})
					.then((value) => {
						$this.$store.dispatch('sound/sfx', 'Button')
					})
			else
				this.$root.$emit('setHomeView', {
					view: 'auction-form',
					target: { ...this.auction },
				})
		},

		htmlToVNode(html) {
			return [this.$createElement('div', { domProps: { innerHTML: html } })]
		},

		formatTime(time) {
			if (time < 0) time = 0 // fix negative
			let t = moment.duration(moment.utc(time).diff(moment.utc() + this.networkTimeDiff))

			if (t.asDays() > 1) return t.days() + 'd' + (t.hours() > 0 ? ' ' + this.pad2(t.hours()) + 'h' : '')
			else if (t.hours() > 0) return this.pad2(t.hours()) + ':' + this.pad2(t.minutes()) + 'h'
			else if (t.minutes() > 0) return this.pad2(t.minutes()) + ':' + this.pad2(t.seconds()) + 'm'

			return '00:' + this.pad2(t.seconds()) + 's'
		},

		pad2(number) {
			if (number < 0) number = 0
			return (number < 10 ? '0' : '') + number
		},

		selfUpdate() {
			const $this = this

			api.auctionsInfo(this.auction.id)
				.then((res) => {
					$this.$emit('updateAuction', res.data)
				})
				.catch((err) => {
					api.baseErrorHendler(err)
				})
		},

		setTimer() {
			const $this = this
			let time = undefined

			this.clearTimers()
			if (!this.auction) return

			// for test only
			// this.auction.endDateTime = "2022-09-08T10:17";

			time = moment.utc(this.auction.status === 'PENDING' ? this.auction.startDateTime : this.auction.endDateTime)

			if (this.isAfterNow(time)) {
				this.lockTime = this.formatTime(time)

				// run timer if limit expiry in one hour
				if (
					moment
						.utc(moment.utc() + $this.networkTimeDiff)
						.subtract(1, 'hours')
						.isBefore(time)
				)
					this.endDateTimer = setInterval(() => {
						let nt = moment.utc() + $this.networkTimeDiff
						if (moment.utc(nt).isBefore(time)) $this.lockTime = $this.formatTime(time)
						else {
							$this.lockTime = ''
							$this.selfUpdate()
							$this.clearTimers()
						}
					}, 1000)
			}
		},

		togggleFavorites(auction) {
			const $this = this

			let req = !auction.favourite ? api.addFavorites(auction.id) : api.deleteFavorites(auction.id)
			req.then((res) => {
				auction.favourite = !auction.favourite
			}).catch((err) => {
				api.baseErrorHendler(err)
			})
		},
	},

	beforeDestroy() {
		this.clearTimers()
	},

	mounted() {
		this.setTimer()
	},

	watch: {
		auction() {
			this.setTimer()
		},
	},
})

export default AuctionListItem
</script>
